































import AppDatatable from '@core/components/AppDatatable.vue'
import { Component, Prop, Vue } from 'vue-property-decorator'
import { HierarchySetupDTO } from '../api'

@Component({
  components: {
    AppDatatable
  }
})
export default class HierarchyDataTable extends Vue {
  @Prop({ default: () => [] }) readonly columns: Array<object>
  @Prop({ default: () => [] }) readonly dataRows: HierarchySetupDTO[]

  txtSearchTop = ''
  loadingTransactions = false

  showHierarchyDetails (row: HierarchySetupDTO) {
    this.$emit('view-hierarchy-row', row)
  }
}
